module.exports = __webpack_public_path__ + "components/wind-icon/static/SW@2x-6d07f9de4c51d2b472604b16ccf88edb.png";